import { BrandBgEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandBgUseRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandBgUseRequestDTO.validationSchema(),
    BrandBgEntity
  );

  constructor(readonly data: RoomBrandBgUseRequest) {
    JsonSchemaValidator.assert(RoomBrandBgUseRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandBg"],
      properties: {
        roomId,
        brandBg: {
          instanceof: BrandBgEntity.name
        }
      }
    };
  }
}

interface RoomBrandBgUseRequest {
  roomId: RoomId;
  brandBg: BrandBgEntity;
}
